// extracted by mini-css-extract-plugin
export default {"container":"PdfViewerPage_container__T3IUr"};